import styled from 'styled-components/macro';

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;